<template>
  <div class="size-finder__tab size-finder__tab--size-guide">
    <div
      v-if="tabContent.fitGuideVideoTab1"
      class="size-finder__video-wrapper"
    >
      <video-player
        class="size-finder__primary-video"
        toolbar-controls
        overlay-needed
        :image="tabContent.fitGuideVideoTab1.preview_image"
        :video="getVideoSource(tabContent.fitGuideVideoTab1.sources)"
      />
    </div>

    <h4
      v-if="tabContent.firstParagraphTitle"
      class="size-finder__tab-heading text-body-m-bold"
      v-text="tabContent.firstParagraphTitle"
    />

    <div
      v-if="tabContent.firstParagraphContent"
      class="size-finder__tab-paragraph"
      v-html="tabContent.firstParagraphContent"
    />

    <size-table
      :table-source="tabContent.tables.gb[0]"
      :enable-unit-toggle="enableUnitToggle"
      :switch-to-inches="switchToInches"
    />

    <size-table
      v-if="tabContent.additionalTable"
      :table-source="tabContent.additionalTable"
      :enable-unit-toggle="enableUnitToggle"
      :switch-to-inches="switchToInches"
    />

    <div
      v-if="tabContent.enableHowTo"
      class="size-finder__howto"
    >
      <h4
        v-if="tabContent.howtoTitle"
        class="size-finder__howto-title text-body-l-bold"
        v-text="tabContent.howtoTitle"
      />

      <ul
        v-if="tabContent.howToBlocks"
        class="size-finder__howto-blocks"
      >
        <template
          v-for="(item, index) of tabContent.howToBlocks"
          :key="index"
        >
          <li class="size-finder__howto-block">
            <div
              v-if="item.image"
              class="size-finder__howto-block-media"
            >
              <responsive-image
                class="size-finder__howto-block-image"
                :image="item.image"
                ratio="100:111"
                sizes="100px"
              />
            </div>

            <div class="size-finder__howto-block-aside">
              <h5
                v-if="item.title"
                class="size-finder__howto-block-title text-body-s-bold text-body-m-bold-desktop"
                v-text="item.title"
              />

              <p
                v-if="item.content"
                class="
                  size-finder__howto-block-content text-body-xs-regular text-body-s-regular-desktop
                "
                v-text="item.content"
              />
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import SizeTable from './size-table'
import ResponsiveImage from '~global/images/responsive-image'
import VideoPlayer from '~async/video-player/video-player'

export default {
  name: 'SizeGuideTab',

  components: {
    SizeTable,
    ResponsiveImage,
    VideoPlayer,
  },

  props: {
    tabContent: {
      type: Object,
      default: () => ({}),
    },
    enableUnitToggle: {
      type: [Boolean, Object],
      default: true,
    },
    switchToInches: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {}
  },

  mounted() {
    this.getActiveGuide()
    this.setDefaultTab()
  },

  methods: {
     /**
     * Check if we want to defualt to inches.
     */
     setDefaultTab() {
      const tablesObject = this.tabContent.tables.gb
      if(this.switchToCoat && tablesObject.length > 1) {
        this.activateGuideButton(1)
      }
    },
    /**
     * Set active guide depending on clicked button.
     * @param {String} index - Clicked button index.
     */
    activateGuideButton(index) {
      if (index === this.activeGuide) {
        return
      }
      const tablesObject = this.tabContent.tables.gb
      this.activeGuide = index
      this.activeGuideTable = tablesObject[index]
    },
    /**
     * Get video MP4 source object.
     * @param {Array} sources - Video sources.
     * @returns {Object}
     */
    getVideoSource(sources) {
      return sources.find((source) => source.format === 'mp4')
    },

    /**
     * Find the first guide which has a sizing table uploaded.
     */
    getActiveGuide() {
      const tablesObject = this.tabContent.tables.gb
      for (let index = 0; index < tablesObject.length; index++) {
        if (tablesObject[index] !== '') {
          this.activeGuide = index
          this.activeGuideTable = tablesObject[index]
          break
        }
      }
    },

  },
}
</script>
